/*eslint-disable*/
define([
  "globals",
  "underscore",
  "knockout",
  "jquery",
  "postal",
  "cookies-factory",
  "cart-count",
  "js-cookie",
  "../../../react/site-bdc/header-modal/index",
  "ko-autocomplete",
  "colorbox"
], function(
  globals,
  _,
  ko,
  $,
  postal,
  cookiesFactory,
  CartCount,
  jsCookie,
  AppModal,
) {
  "use strict";

  AppModal.default();

  return function HeaderViewModel() {
    var self = this;
    var cartCount = new CartCount();

    var useDelorean = globals.siteId === 3;
    self.searchValue = ko.observable();
    self.cartItemCount = ko.observable(0);
    self.channel = postal.channel("cart");

    self.name = ko.computed(function() {
      if (cookiesFactory.userName() === undefined) {
        return "";
      }
      return cookiesFactory.userName();
    });

    self.showName = ko.computed(function() {
      return self.name() !== "";
    });

    self.internalName = ko.computed(function() {
      if (cookiesFactory.userName() === undefined) {
        return "";
      }
      return "logged in as: " + cookiesFactory.userName();
    });

    self.dateAsOf = ko.computed(function() {
      if (cookiesFactory.dateAsOf() === undefined) {
        return "";
      }
      return cookiesFactory.dateAsOf();
    });

    self.showTime = ko.computed(function() {
      return self.dateAsOf() !== "";
    });

    self.showSurefit = function(viewModel, event) {
      event.preventDefault();
      $.colorbox({
        href: event.target.href,
        transition: "none",
        width: "600px",
        maxWidth: "95%",
        maxHeight: "95%"
      });
    };

    self.dispatchLoginStatusChangeEvent = function(isLoggedIn) {
      const loginStatusChangeEvent = new CustomEvent("loginStatusChange", {
        detail: {
          taskName: "loginStatusChange",
          isLoggedIn
        }
      });

      document.dispatchEvent(loginStatusChangeEvent);
    };

    self.getAuthStatus = function(isAuthenticated) {
      if (jsCookie.get("internalUser")) {
        return "rep";
      } else if (isAuthenticated) {
        return "consumer";
      }
      return "guest";
    };

    self.handleAuthStatus = function(authData) {
      var cartCountObject = $("[data-cart-count]");
      cartCount.updateCartCount(authData.ItemCount, cartCountObject);
      self.cartItemCount(authData.ItemCount);
      cartCountObject.attr("data-cart-count", authData.ItemCount);
      self.dispatchLoginStatusChangeEvent(authData.IsAuthenticated);
      var body = $(document.body);
      if (authData.HasMandiMeasureLineItem) {
        body.attr(
          "data-has-mandi-measure-line-item",
          authData.HasMandiMeasureLineItem
        );
      } else {
        body.removeAttr("data-has-mandi-measure-line-item");
      }

      if (authData.IsAuthenticated) {
        body.attr("data-is-authenticated", authData.IsAuthenticated);
      } else {
        body.removeAttr("data-is-authenticated");
      }

      $(document).trigger({
        type: "cartUpdated"
      });
    };

    self.updateHeaderWithLoginStatus = function() {
      if (window.cartwithloginstatus) {
        self.handleAuthStatus(window.cartwithloginstatus);
      } else {
        $.ajax(globals.globalPaths.getCartWithLoginStatus)
          .done(function(response) {
            self.handleAuthStatus(response);
          })
          .fail(function() {
            self.cartItemCount(0);
            $(document).trigger({
              type: "cartUpdated"
            });
          });
      }
    };

    self.channel.subscribe("cart.list.updated", function() {
      self.updateHeaderWithLoginStatus();
    });

    document.addEventListener("cart.list.updated", function() {
      self.updateHeaderWithLoginStatus();
    });

    self.channel.subscribe("new.cart", function() {
      self.updateHeaderWithLoginStatus();
    });
    self.updateHeaderWithLoginStatus();

    $("#gcc-header-topnav-myaccount-sign-in").click(e => {
      const loginEvent = new CustomEvent("loginRequested", {
        detail: {
          taskName: "open modal"
        }
      });

      var blockSignIn = window.location.href,
        preCheckout = "/Ordering/Checkout/Signin";
      if (blockSignIn.indexOf(preCheckout) === -1) {
        document.dispatchEvent(loginEvent);
      }
    });

    $("#gcc-header-topnav-create-estimate").click(e => {
      const estimateModalEvent = new CustomEvent("createEstimate", {
        detail: {
          taskName: "open modal"
        }
      });

      document.dispatchEvent(estimateModalEvent);
    });

    $("#exitEstimateModeLink").click(e => {
      const exitEstimateModalEvent = new CustomEvent("exitEstimate", {
        detail: {
          taskName: "open modal"
        }
      });

      document.dispatchEvent(exitEstimateModalEvent);
    });
  };
});
